import * as z from "zod";

export const deleteThirdPartyBillingAccount = {
  name: "deleteThirdPartyBillingAccount" as const,
  input: z.object({ accountId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
